import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
    Grid,
    Paper,
    Typography,
    ButtonGroup,
    Button,
    FormControl,
    MenuItem,
    TextField,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import FastForwardIcon from '@mui/icons-material/FastForward';
import FastRewindIcon from '@mui/icons-material/FastRewind';

import {
    incrementRoutePageIndex, decrementRoutePageIndex,
    setRoutesPerPage, routePageIndexSelector, routePageCountSelector,
    routesPerPageSelector,
} from '../../../features/tripcenter/routeSlice';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: useTheme().spacing(1),
        width: 100,
    },
    selectEmpty: {
        marginTop: useTheme().spacing(2),
    },
}));

const perPageOptions = [10, 25, 50, 100];

const RoutesBarPaginate = () => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const routePageIndex = useSelector(routePageIndexSelector);
    const routePageCount = useSelector(routePageCountSelector);
    const routesPerPage = useSelector(routesPerPageSelector);

    const [perPage, setPerPage] = useState(10);

    useEffect(() => {
        setPerPage(routesPerPage);
    }, [routesPerPage]);

    const onPerPage = (e) => {
        setPerPage(e.target.value);
        dispatch(setRoutesPerPage(e.target.value));
    }

    return (
        <div style={{ marginTop: '2px', marginBottom: '2px' }}>
            <Paper>
                <Grid
                    container
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    alignContent="center"
                    wrap='wrap'
                    spacing={1}
                    style={{
                        marginLeft: '5px',
                        marginBottom: '5px',
                    }}
                >
                    <Grid item sm={7}>
                        <ButtonGroup size="small">
                            <Button
                                startIcon={<FastRewindIcon color="primary" />}
                                onClick={() => dispatch(decrementRoutePageIndex())}
                                disabled={routePageIndex === 1}
                            />
                            <Button>
                                <Typography variant="body1" align="center">
                                    Page: {routePageIndex}/{routePageCount}
                                </Typography>
                            </Button>
                            <Button
                                endIcon={<FastForwardIcon color="primary" />}
                                onClick={() => dispatch(incrementRoutePageIndex())}
                                disabled={routePageIndex === routePageCount}
                            />
                        </ButtonGroup>
                    </Grid>

                    <Grid item sm={5}>
                        <FormControl className={classes.formControl}>
                            <TextField
                                id="routesPerPageSelect"
                                select
                                value={perPage}
                                onChange={onPerPage}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">Per Page:</InputAdornment>,
                                }}
                            >
                                {
                                    perPageOptions.map(option => <MenuItem key={option} value={option}>{option}</MenuItem>)
                                }
                            </TextField>
                        </FormControl>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    );
}

export default RoutesBarPaginate; 